import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { Star, Quote } from "lucide-react";
import Hero from "@/components/Hero";
import { lazy, Suspense } from "react";
import heroImage from "@/assets/hero.avif";
const NewHomepageContent = lazy(() => import("@/components/NewHomepageContent"));
const Home = () => {
  return <div className="min-h-screen">
      {/* Hero Section with LCP-optimized image */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <img src={heroImage} alt="Kijani Arusha Airport Lodge - Safari accommodation in Arusha, Tanzania" className="absolute inset-0 w-full h-full object-cover" width="1920" height="1080" loading="eager" />
        <div className="absolute inset-0 bg-black/50"></div>
        <div className="relative z-10 text-white max-w-4xl ml-4 md:ml-8 px-4 text-left">
          <h1 className="font-heading text-3xl md:text-6xl font-bold mb-2 md:mb-4 lg:text-5xl">
            Welcome to Kijani Arusha Airport Lodge
          </h1>
          <p className="text-xl font-light mb-6 md:mb-8 opacity-90 md:text-sm">
            Your peaceful sanctuary before and after safari adventures.
          </p>
          
          <Button size="lg" asChild className="bg-primary hover:bg-primary/90 text-primary-foreground shadow-elegant px-8 py-3">
            <Link to="/book">BOOK YOUR STAY</Link>
          </Button>
        </div>
      </section>

      {/* Main Content with Parallax Background */}
      <Suspense fallback={<div className="min-h-screen" />}>
        <NewHomepageContent />
      </Suspense>

      {/* Reviews Section */}
      <section className="py-20 bg-muted">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="font-heading text-4xl font-bold text-foreground mb-6">
              What Our Guests Say
            </h2>
            <p className="text-muted-foreground max-w-2xl mx-auto">
              Read about the unforgettable experiences our guests have had at Kijani Arusha Airport Lodge
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <Card className="bg-card shadow-soft">
              <CardContent className="p-6">
                <div className="flex items-center mb-4">
                  {Array.from({
                  length: 5
                }, (_, i) => <Star key={i} className="h-5 w-5 text-yellow-400 fill-current" />)}
                </div>
                <Quote className="h-8 w-8 text-primary mb-4" />
                <p className="text-muted-foreground mb-4 italic">
                  "Absolutely wonderful stay! The personalized service made us feel like family. 
                  The location is perfect for safari trips, and the peaceful garden setting was exactly what we needed to unwind."
                </p>
                <div className="text-sm">
                  <p className="font-semibold text-foreground">Sarah & Michael Johnson</p>
                  <p className="text-muted-foreground">United Kingdom</p>
                </div>
              </CardContent>
            </Card>
            
            <Card className="bg-card shadow-soft">
              <CardContent className="p-6">
                <div className="flex items-center mb-4">
                  {Array.from({
                  length: 5
                }, (_, i) => <Star key={i} className="h-5 w-5 text-yellow-400 fill-current" />)}
                </div>
                <Quote className="h-8 w-8 text-primary mb-4" />
                <p className="text-muted-foreground mb-4 italic">
                  "The perfect safari gateway! Being just 7 minutes from the airport was incredibly convenient. 
                  The staff knew our names and preferences from day one. Truly exceptional hospitality!"
                </p>
                <div className="text-sm">
                  <p className="font-semibold text-foreground">Hans & Ingrid Mueller</p>
                  <p className="text-muted-foreground">Germany</p>
                </div>
              </CardContent>
            </Card>
            
            <Card className="bg-card shadow-soft">
              <CardContent className="p-6">
                <div className="flex items-center mb-4">
                  {Array.from({
                  length: 5
                }, (_, i) => <Star key={i} className="h-5 w-5 text-yellow-400 fill-current" />)}
                </div>
                <Quote className="h-8 w-8 text-primary mb-4" />
                <p className="text-muted-foreground mb-4 italic">
                  "A peaceful oasis nestled in lush greenery. With only 9 rooms, it never felt crowded. 
                  The perfect place to relax before and after our Tanzania adventures."
                </p>
                <div className="text-sm">
                  <p className="font-semibold text-foreground">David & Emma Chen</p>
                  <p className="text-muted-foreground">Australia</p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-primary text-primary-foreground">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="font-heading text-4xl font-bold mb-6">
            Ready for Your Safari Adventure?
          </h2>
          <p className="text-xl mb-8 opacity-90">
            Book your stay at Kijani Arusha Airport Lodge and experience authentic Tanzanian hospitality
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button size="lg" variant="secondary" asChild>
              <Link to="/book">Book Your Stay</Link>
            </Button>
            <Button size="lg" variant="outline" asChild className="border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-primary">
              <Link to="/contact">Contact Us</Link>
            </Button>
          </div>
        </div>
      </section>
    </div>;
};
export default Home;